import React from 'react';
import { Link } from 'react-router-dom';
import footerLogo from '../../../assets/images/resources/bsides-logo.png';

const Footer = () => {
  return (
    <>
    <footer className="site-footer">
        <div className="site-footer__top">
            <div className="container">
                <div className="site-footer__top-inner">
                    <div className="site-footer__logo">
                        <Link to="/"><img src={footerLogo} alt="BSides Coimbatore" style={{height:'60px',width:'auto'}} /></Link>
                    </div>
                    <div className="site-footer__social">
                        <a href="https://twitter.com/BSidesCBE" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
                        <a href="https://discord.gg/bsidescoimbatore" target="_blank" rel="noreferrer"><i className="fab fa-discord"></i></a>
                        <a href="https://instagram.com/bsidescbe" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                        <a href="https://linkedin.com/company/bsidescoimbatore" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
                        <a href="https://youtube.com/@bsidescoimbatore" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
                    </div>
                </div>
            </div>
        </div>

        <div className="site-footer__middle">
            <div className="container">
                <div className="site-footer__middle-inner">
                    <div className="row">
                        {/* Conference */}
                        <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div className="footer-widget__column footer-widget__link">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Conference 2027</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/bsides-contact">Register — Free</Link></li>
                                    <li><Link to="/bsides-contact">Call for Papers</Link></li>
                                    <li><Link to="/schedule">Schedule</Link></li>
                                    <li><Link to="/speakers">Speakers</Link></li>
                                    <li><Link to="/bsides-contact">CTF Competition</Link></li>
                                </ul>
                            </div>
                        </div>

                        {/* Community */}
                        <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div className="footer-widget__column footer-widget__our-company">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Community</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/about-us">About Us</Link></li>
                                    <li><Link to="/community-events">Community Events</Link></li>
                                    <li><Link to="/volunteers">Volunteer with Us</Link></li>
                                    <li><Link to="/bsides-contact">Join the Event</Link></li>
                                    <li><a href="https://bsides.org" target="_blank" rel="noreferrer">Security BSides Global</a></li>
                                    <li><a href="https://discord.gg/bsidescoimbatore" target="_blank" rel="noreferrer">Join our Discord</a></li>
                                </ul>
                            </div>
                        </div>

                        {/* Contact */}
                        <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                            <div className="footer-widget__column footer-widget__contact">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Contact Us</h3>
                                </div>
                                <div className="footer-widget__contact-inner">
                                    <ul className="footer-widget__contact-list list-unstyled">
                                        <li>
                                            <div className="icon"><span className="icon-envelop"></span></div>
                                            <div className="text"><p><a href="mailto:info@bsidescoimbatore.in">info@bsidescoimbatore.in</a></p></div>
                                        </li>
                                        <li>
                                            <div className="icon"><span className="icon-pin"></span></div>
                                            <div className="text"><p>CODISSIA Trade Fair Complex,<br />Coimbatore, Tamil Nadu</p></div>
                                        </li>
                                        <li>
                                            <div className="icon"><span className="fas fa-phone-alt" style={{ fontSize: "16px" }}></span></div>
                                            <div className="text"><p><a href="tel:+919876543210">+91 98765 43210</a></p></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="site-footer__bottom">
            <div className="container">
                <div className="site-footer__bottom-inner">
                    <p className="site-footer__bottom-text">© BSides Coimbatore 2027 · All Rights Reserved · Made with ❤ for the security community</p>
                    <ul className="list-unstyled site-footer__bottom-menu">
                        <li><Link to="/bsides-contact">Code of Conduct</Link></li>
                        <li><Link to="/bsides-contact">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    </>
  );
};

export default Footer;
